import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TempUser, VendorRegistrationData } from '@org/interfaces';
import { environment } from '@org/shared-services';
import { VendorUser } from '@org/utilities';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TempUserService {
  private apiUrl = `${environment.apiUrl}/api/tempuser`;
  private tempUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public tempUser$: Observable<any> = this.tempUserSubject.asObservable();

  constructor(private http: HttpClient) { }

  // Vendor Approval
  getPendingVendors(tenantId: string): Observable<TempUser[]> {
    return this.http.get<TempUser[]>(`${this.apiUrl}/data/${tenantId}`);
  }

  approveVendor(tempUserId: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/updateApprovalStatus`, {
      tempUserId: tempUserId,
      status: true
    });
  }

  rejectVendor(tempUserId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete/${tempUserId}`);
  }
}
